import React from 'react'
import Nav from '../Nav'
import About from '../About'
import Footer from '../Footer'

function AboutPage() {
    return (
        <>
            <Nav />
            <About />
            <Footer />
        </>
    )
}

export default AboutPage
